import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Box, Text} from '@chakra-ui/react';
import {SearchIcon} from '@chakra-ui/icons';
import './Search.css';

const Search = ({setLoading, setResult, setShowResult}) => {
  const {t} = useTranslation();

  const [inputValue, setInputValue] = useState('');
  const [error, setError] = useState('');

  const machinesEndpoint = process.env.REACT_APP_MACHINES_ENDPOINT;

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
    if (event.target.value.trim() !== '') {
      setError('');
    }
  };

  const handleSearch = async (event) => {
    event.preventDefault();

    if (inputValue.trim() === '') {
      setError(t('errorEmptyField'));
      return;
    }

    const isValid = /^[A-Za-z0-9]*$/.test(inputValue);

    if (!isValid) {
      setError(t('errorSpecialCharacters'));
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(
          `${machinesEndpoint}/${encodeURIComponent(
              inputValue)}?language=${Liferay.ThemeDisplay.getLanguageId()}`);
      if (!response.ok) {
        throw new Error('Error loading the data');
      }
      const data = await response.json();
      setResult(data);

      if (data.message !== null) {
        console.log(data.message)
      }
    } catch (error) {
      console.error('Error:', error);
      setResult(null);
    } finally {
      setLoading(false);
      setShowResult(true);
    }
  }

  return (
      <Box as="form" onSubmit={handleSearch} mb={4}>
        <Box className="form-group form__label-group form__input-button-group">
          <input id="inputSearch"
                 className="form-control"
                 type="text"
                 placeholder={t('inputPlaceholder')}
                 onChange={handleInputChange}
          />
          <label htmlFor="inputSearch">{t('inputPlaceholder')}</label>
          <button type="submit" className="btn btn-primary">
            <SearchIcon/>
          </button>
        </Box>
        {error && <Text className="text--putzmeister-status-red" mt={1}>{error}</Text>}
      </Box>
  );
}

export default Search;